import React from 'react';

import { Translate } from 'react-localize-redux';
import AppState from '@webapp/store/state';
import { RemoveTeamMember } from '@webapp/store/teams/action-creators';
import {
  CreateTeamMember,
  UpdateTeamMember,
} from '@webapp/store/teams/action-creators';
import { Dispatch } from 'redux';
import { connect } from 'react-redux';
import { TeamMemberRole, TeamMember } from '@services/teams/types/team-member';
import { Option } from '@webapp/types/common/option';
import { RecordLabel } from '@common/types/record-label/record-label';
import OperatorLabelInviteCtrl from '../../operator-label-invite';
import { UserSearchResult } from '@webapp/types/user-search-result';
import { normalizePhoneOrEmail } from '@webapp/utils/normalizers';
import OperatorItem from '../operator-item';
import InputTabSelector from '@webapp/controllers/input-tab-selector';
import Flex from '@components/layout/flex';
import { NewTeamMember } from '@services/teams/types/new-team-member';

interface TeamProps {
  className?: string;
  members: TeamMember[];
  addMember: (member: NewTeamMember) => CreateTeamMember;
  removeMember: (member: TeamMember) => RemoveTeamMember;
  onChangeRole: (member: TeamMember, role: TeamMemberRole) => UpdateTeamMember;
  recordLabel: RecordLabel;
  ownerId: string;
}

const mapStateToProps = (state: AppState) => ({
  members: state.teams.teamMembers,
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
  removeMember: (member: TeamMember) => dispatch(new RemoveTeamMember(member)),
  addMember: (member: NewTeamMember) => dispatch(new CreateTeamMember(member)),
  onChangeRole: (member: TeamMember, role: TeamMemberRole) =>
    dispatch(new UpdateTeamMember({ ...member, role })),
});

const TEAM_ROLES: Option<TeamMemberRole>[] = [
  { label: 'Admin', value: 'admin' },
  { label: 'Operator', value: 'operator' },
];

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(function Team(props: TeamProps) {
  const [newOperator, setNewOperator] =
    React.useState<Partial<UserSearchResult>>();

  const operatorAsTeamMember = (member: TeamMember): UserSearchResult => {
    return {
      id: member.id,
      name: member.name,
      avatar: '',
      contact: '',
      type: 'user',
      helpText: member.name,
    };
  };

  const handleSelection = (operator: UserSearchResult) => {
    setNewOperator(undefined);
    const contact = normalizePhoneOrEmail(operator.contact);

    if (!contact) {
      return;
    }
    props.addMember({
      id: operator.id,
      labelId: props.recordLabel.id,
      name: operator.name,
      avatar: operator.avatar,
      role: 'admin',
    });
  };

  return (
    <>
      <OperatorLabelInviteCtrl
        label={<Translate id="USER_PROFILE.ROSTER.OPERATOR.NEW" />}
        className={`${props.members.length >= 1 ? 'mb-40' : ''}`}
        value={newOperator as UserSearchResult}
        currentValues={props.members.map(operatorAsTeamMember)}
        role="operator"
        type="operator"
        recordLabel={props.recordLabel}
        onChange={(value) => setNewOperator({ ...newOperator, name: value })}
        onSelection={(operator) => handleSelection(operator)}
        songName=""
      />
      {props.members.map((member) => (
        <Flex style={{ display: 'block' }}>
          <OperatorItem
            key={member.id}
            src={member.avatar}
            name={member.name}
            labelId={member.labelId}
            userId={member.id}
            onRemove={(_labelId, _userId) => {
              props.removeMember(member);
            }}
          />
          <InputTabSelector
            value={member.role}
            options={TEAM_ROLES}
            isDisabled={false}
            onClick={(value) => props.onChangeRole(member, value)}
          />
        </Flex>
      ))}
    </>
  );
});
